import { createAsyncThunk } from '@reduxjs/toolkit';
import { PrizeService } from '../services/prize.service';
import { showCriticalAlert } from './common.actions';
import i18n from '../i18n';

export const fetchPrizes = createAsyncThunk(
    'prize/fetchPrizes',
    async (_, { rejectWithValue, dispatch }) => {
        try {
            const prizeData = await PrizeService.getPrizes();
            return prizeData;
        } catch (error) {
            dispatch(showCriticalAlert(i18n.t('epic.common.network.error')));
            return rejectWithValue(
                error instanceof Error ? error.message : 'Unknown error occurred'
            );
        }
    }
);
